import React from 'react'

const team = [
  {
    img: 'img/team/charlotte.jpg',
    name: 'Charlotte Devaux',
    job: 'Vétérinaire, cofondatrice, nutrition & contenu.',
    lk: 'https://www.linkedin.com/in/charlotte-devaux-6467a4128/',
  },
  {
    img: 'img/team/Louis.jpeg',
    name: 'Louis-Gabriel Mognetti',
    job: 'Vétérinaire, cofondateur, développement & produit.',
    lk: 'https://www.linkedin.com/in/louis-gabriel-m-131334120/',
  },
]

const Team = () => (
  <section className="vt-section cream" id="team">
    <div className="vt-shell">
      <div className="tc" style={{ maxWidth: 660, margin: '0 auto 48px' }}>
        <span className="eyebrow">Le bestiaire</span>
        <h2>Charlotte &amp; Louis.</h2>
        <p className="muted" style={{ margin: '0 auto' }}>
          Deux vétos, un produit. Pas de storytelling — juste du boulot bien fait, ensemble.
        </p>
      </div>
      <div className="grid2" style={{ maxWidth: 720, margin: '0 auto' }}>
        {team.map((t, i) => (
          <div className="tm" key={i}>
            <div className="ph">
              <img src={t.img} alt={t.name} />
            </div>
            <h4>{t.name}</h4>
            <p className="job">{t.job}</p>
            <a className="lk" href={t.lk} target="_blank" rel="noopener noreferrer">
              <i data-lucide="arrow-up-right"></i>
            </a>
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default Team;
